import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

import { examsAPI } from 'common/api/examsAPI'

export const fetchExams = createAsyncThunk(
  'dashboard/fetchExams',
  async (_, { rejectWithValue }) => {
    try {
      return await examsAPI.getExams()
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return rejectWithValue(e.message)
      }
    }
  }
)
